import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, TextField, Button, Stack } from '@mui/material';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

const WebhooksManagement: React.FC = () => {
  const navigate = useNavigate();
  const [url, setUrl] = useState('');
  const [secret, setSecret] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  const save = async () => {
    await api.post('/webhooks/config', { url, secret });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 3 }}>
        Webhook Yönetimi
      </Typography>
      <Card>
        <CardContent>
          <Stack spacing={2}>
            <TextField label="Webhook URL" fullWidth value={url} onChange={e => setUrl(e.target.value)} />
            <TextField label="Gizli Anahtar" fullWidth value={secret} onChange={e => setSecret(e.target.value)} />
            <Button variant="contained" onClick={save}>Kaydet</Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default WebhooksManagement;

